// extracted by mini-css-extract-plugin
module.exports = {"root":"QuoteSaasItems_root__2Aucl"};